import { Schema } from '@effect/schema';
import { ParticleId } from '../../particleId';
import { Array } from 'effect';
import { PrologRuleId } from './prologRule';
export const PrologRules = Schema.Struct({
    prolog: PrologRuleId,
});
export const MatchRules = Schema.Struct({
    match: Schema.Array(Schema.Struct({
        includeParticles: Schema.Array(ParticleId),
    })),
});
export const isPrologRules = Schema.is(PrologRules);
export const isMatchRules = Schema.is(MatchRules);
export const Part = Schema.Struct({
    cardinality: Schema.Array(Schema.Number),
    name: Schema.String,
    hero: Schema.optional(Schema.Boolean),
});
export const Structure = Schema.Struct({
    parts: Schema.Array(Part),
});
export const Template = Schema.Struct({
    rules: Schema.Union(MatchRules, PrologRules),
    type: Schema.String,
    structure: Structure,
    properties: Schema.optional(Schema.Union(Schema.Map({
        key: Schema.String,
        value: Schema.Union(Schema.String, Schema.Number, Schema.Null),
    }), Schema.Null)),
});
export const TemplateId = Schema.String.pipe(Schema.brand('@fixtuur/backpack/TemplateId'));
export const TemplateWithId = Schema.Tuple(TemplateId, Template);
export const Templates = Schema.Array(TemplateWithId);
export const addPart = (template, part) => {
    const parts = [...template.structure.parts, part];
    const structure = Structure.make({
        parts,
    });
    // match rule segments and parts have a relationship
    const rules = isMatchRules(template.rules)
        ? MatchRules.make({ match: template.rules.match.concat({ includeParticles: [] }) })
        : template.rules;
    return Template.make({
        ...template,
        structure,
        rules,
    });
};
export const removePart = (template, partIndex) => {
    const parts = Array.remove(template.structure.parts, partIndex);
    if (isPrologRules(template.rules)) {
        return Template.make({
            ...template,
            structure: { parts },
        });
    }
    // parts + rule segments are pairs for match rules, so be sure to remove the
    // matching rules at the same time.
    const match = Array.remove(template.rules.match, partIndex);
    return Template.make({
        ...template,
        structure: { parts },
        rules: MatchRules.make({ match }),
    });
};
/**
 * Replace the part at the specified index with an updated Part
 */
export const replacePart = (template, partIndex, part) => {
    const parts = Array.replace(template.structure.parts, partIndex, part);
    return Template.make({
        ...template,
        structure: { parts },
    });
};
/**
 * Replace the match segment at the specified index with an updated list of Particles
 */
export const replaceMatchSegment = (template, segmentIndex, particles) => {
    if (isPrologRules(template.rules)) {
        return template;
    }
    const match = Array.replace(template.rules.match, segmentIndex, {
        includeParticles: particles,
    });
    return Template.make({
        ...template,
        rules: MatchRules.make({ match }),
    });
};
